const vh = (percent: number) => {
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    return (percent * h) / 100;
}
const modalListHeight = () => { return `${window.document.body.clientHeight - vh(16)}px` };

export { vh, modalListHeight }